import React, { useContext, useEffect, useState } from 'react';
import { StockLocationContext } from '../../../../../../../context/StockLocationContext';
import {
  StockLocationMutations,
  UpdateStockLocationResponse,
  UpdateStockLocationVariables,
} from '../../../../../../../graphql/stockLocation.graphql';
import useMutation from '../../../../../../../hooks/useMutation';
import { useToast } from '../../../../../../../providers/ToastProvider';
import { EntityType } from '../../../../../../../types/comment';
import { StockLocation } from '../../../../../../../types/stock_location/stockLocation';
import { StockLocationInput } from '../../../../../../../types/stock_location/stockLocation.input';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../../types/translation/Translator';
import { ButtonVariant } from '../../../../../../components/Button';
import SaveChangesButton from '../../../../../../components/Button/templates/SaveChangesButton';
import EntityTagMultiSelect from '../../../../../../components/Dropdown/templates/TagMultiSelect/EntityTagMultiSelect';
import { ToastType } from '../../../../../../components/Toast';
import StockLocationInputPane from '../../panes/StockLocationInputPane';

interface StockLocationDetailsPaneProps {
  stockLocation: StockLocation;
}

export default function StockLocationDetailsPane({ stockLocation }: StockLocationDetailsPaneProps) {
  const { showToast } = useToast();

  const { stockLocations, setStockLocations } = useContext(StockLocationContext);

  const [input, setInput] = useState(new StockLocationInput(stockLocation));

  useEffect(() => setInput(new StockLocationInput(stockLocation)), [stockLocation]);

  const [update, { loading }] = useMutation<UpdateStockLocationResponse, UpdateStockLocationVariables>(
    StockLocationMutations.update,
    {
      variables: { stockLocations: [input.forUpdate()] },
      onCompleted: response => {
        const updatedLocation = response.updateStockLocation[0];
        setStockLocations(new Map(stockLocations).set(updatedLocation.id, updatedLocation));
        showToast({
          type: ToastType.success,
          title: t(TranslationKey.stockLocationUpdatedSuccessfullyToast).singular.upper,
        });
      },
    },
  );

  return (
    <div className='flex flex-grow flex-col overflow-auto'>
      <StockLocationInputPane
        input={input}
        setInput={setInput}
        tagInput={<EntityTagMultiSelect entityId={stockLocation.id} entityType={EntityType.stockLocation} />}
        footer={
          <div>
            <SaveChangesButton
              className='w-fit'
              variant={ButtonVariant.primary}
              onClick={() => update()}
              loading={loading}
              disabled={!input.validate() || !input.hasChanges(stockLocation)}
            />
          </div>
        }
      />
    </div>
  );
}
